import { render, staticRenderFns } from "./PaperPlaneIcon.vue?vue&type=template&id=1b94de60&"
import script from "./PaperPlaneIcon.vue?vue&type=script&lang=js&"
export * from "./PaperPlaneIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports